import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-employees'

export const getAllEmployees = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const updateStatus = async (token, id, newStatus) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-status`, {
        id: id,
        status: newStatus
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const getWorkTimeByEmployeeId = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-work-time-by-employee-id`, {
        id: id
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const logoutWorkTimeById = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/logout-work-time-by-id`, {
        id: id
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const register = async (username, password) => {
    const response = await axios.post(`${host}/employee-lottmekong-register`, {
        username: username,
        password: password
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const getAvailableGames = async (token) => {
    const response = await axios.get(`${host}/${PLUGINS_NAME}/available-games`, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const assignGame = async (token, employeeId, gameId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/assign-game`, {
        id: employeeId,
        gameId: gameId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const createEmployeeWithGame = async (token, employeeData) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/create-with-game`, employeeData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 201) {
        return response.data || {}
    }
    return false
}

export const createEmployeeWithMultipleGames = async (token, employeeData) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/create-with-multiple-games`, employeeData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 201) {
        return response.data || {}
    }
    return false
}

export const assignMultipleGames = async (token, employeeId, gameIds) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/assign-multiple-games`, {
        id: employeeId,
        gameIds: gameIds
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateEmployeeInfo = async (token, employeeData) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-info`, employeeData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}
